module.exports = __webpack_public_path__ + "media/images/area/icon_weather_14-5d9328ae1c85670a0d58b839938fc44b.png";